import { FORM_TAB_BOXES } from "form/model"
import { state } from "../state"

export function getIsTabBoxOpened(id: FORM_TAB_BOXES): boolean {
  return state.tabBoxIsOpenedById[id]
}

export function rememberTabBoxIsOpened(id: FORM_TAB_BOXES, isOpened: boolean): void {
  state.tabBoxIsOpenedById[id] = isOpened
}

export function resetTabBoxesState(): void {
  state.tabBoxIsOpenedById = getDefaultBoxState()
}

export function getDefaultBoxState(): { [boxId in FORM_TAB_BOXES]: boolean } {
  return {
    [FORM_TAB_BOXES.CONFIGURATION_MAIN]: true,
    [FORM_TAB_BOXES.CONFIGURATION_BUDGET]: true,
    [FORM_TAB_BOXES.CONFIGURATION_SCHEDULE]: false,
    [FORM_TAB_BOXES.CONFIGURATION_CAPS]: false,
    [FORM_TAB_BOXES.SCREENS_ENVIRONMENTS]: false,
    [FORM_TAB_BOXES.SCREENS_SSP]: false,
    [FORM_TAB_BOXES.SCREENS_SSP_DEALS]: false,
    [FORM_TAB_BOXES.CREATIVE_CAMPAIGN_LIST]: true,
    [FORM_TAB_BOXES.CREATIVE_FORECAST_LIST]: true
  }
}

export function hilightTabBox(tabBox: FORM_TAB_BOXES): void {
  if (tabBox.startsWith("configuration")) {
    hilightConfigurationTabBox(tabBox)
    return
  } else if (tabBox.startsWith("creative")) {
    hilightCreativeTabBox(tabBox)
    return
  }
  hilightScreensTabBox(tabBox)
}

function hilightConfigurationTabBox(tabBox: FORM_TAB_BOXES): void {
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CONFIGURATION_MAIN] = tabBox === FORM_TAB_BOXES.CONFIGURATION_MAIN
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CONFIGURATION_BUDGET] = tabBox === FORM_TAB_BOXES.CONFIGURATION_BUDGET
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CONFIGURATION_SCHEDULE] = tabBox === FORM_TAB_BOXES.CONFIGURATION_SCHEDULE
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CONFIGURATION_CAPS] = tabBox === FORM_TAB_BOXES.CONFIGURATION_CAPS
}

function hilightCreativeTabBox(tabBox: FORM_TAB_BOXES): void {
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CREATIVE_CAMPAIGN_LIST] = tabBox === FORM_TAB_BOXES.CREATIVE_CAMPAIGN_LIST
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.CREATIVE_FORECAST_LIST] = tabBox === FORM_TAB_BOXES.CREATIVE_FORECAST_LIST
}

function hilightScreensTabBox(tabBox: FORM_TAB_BOXES): void {
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.SCREENS_ENVIRONMENTS] = tabBox === FORM_TAB_BOXES.SCREENS_ENVIRONMENTS
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.SCREENS_SSP] = tabBox === FORM_TAB_BOXES.SCREENS_SSP
  state.tabBoxIsOpenedById[FORM_TAB_BOXES.SCREENS_SSP_DEALS] = tabBox === FORM_TAB_BOXES.SCREENS_SSP_DEALS
}
